<template>
  <div id="table-exhibition" class="result-table">
    <el-table
      stripe
      border
      :data="results"
      @expand="fetchExhibitionSection"
      @sort-change="setOrderColumn">
      <el-table-column type="expand">
        <template slot-scope="props">
          <p v-if="props.row.space">
            {{$t('pages.results.address')}} : {{props.row.space}}
          </p>
          <p v-if="props.row.notes">
            {{$t('pages.results.notes')}} : {{props.row.notes}}
          </p>
          <div
            v-if="props.row.exhibitionCatalog"
            v-loading="props.row.exhibitionCatalog.loading"
            v-for="result in props.row.exhibitionCatalog.results"
            :key="result.id"
          >
            <ExhibitionCatalog :exhibitionCatalog="result"></ExhibitionCatalog>
          </div>
          <p v-if="props.row.exhibitionCatalog.results[0] && props.row.exhibitionCatalog.results[0].source_catalog === null">
            {{$t('pages.results.sourceExhbition')}} : {{props.row.source}}
          </p>
          <cite>
            {{$t('pages.results.credits')}}
            {{$t('pages.results.filledBy')}}
            <span v-if="props.row.contributor">{{ props.row.contributor }}.</span>
            <span v-else>{{$t('pages.results.contributorUnkown')}}</span>
          </cite>
        </template>
      </el-table-column>
      <el-table-column
        prop="begin_year"
        sortable
        :label="$t('pages.results.year')"
        width="120">
      </el-table-column>
      <el-table-column
        prop="city"
        sortable
        width="140"
        :label="$t('pages.results.city')">
      </el-table-column>
      <el-table-column
        prop="title"
        sortable
        @click="helloWorld"
        :label="$t('pages.results.exhibitionTitle')">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  Table, TableColumn, Button, Tooltip
} from 'element-ui'
import ExhibitionCatalog from '../../ExhibitionCatalog/ExhibitionCatalog'

import { formatDate } from '../../../services/formatter'
import { GET_EXHIBITION_SECTION_FILTERED_BY_COLUMN } from '@/store/search/constants'

export default {
  name: 'table-exhibition',
  props: ['results', 'setOrderColumn'],
  methods: {
    formatCatalogUrl (id) {
      return 'catalog/' + id
    },
    helloWorld () {
      console.log('hello world')
    },
    formatDate,
    fetchExhibitionSection (row, expanded) {
      if (expanded === true) {
        // dispatch action to load exhibited work for row.id exhibitor
        this.$set(row, 'exhibitionCatalog', {})
        this.$store.dispatch('search/' + GET_EXHIBITION_SECTION_FILTERED_BY_COLUMN, {
          value: row.id,
          column: 'id_exhibition',
          objectToIncrement: row.exhibitionCatalog
        })
      }
    }
  },
  components: {
    elTable: Table,
    elTableColumn: TableColumn,
    elButton: Button,
    elTooltip: Tooltip,
    ExhibitionCatalog: ExhibitionCatalog
  }
}
</script>

<style>
.result-table .el-table__expanded-cell {
  padding: 16px 20px;
}
.sources {
  position: relative;
  margin: 0;
  padding-left: 50px;
  color: #97a8be;
}
.exhibition-id {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 13px;
  font-weight: bold;
  color: #97a8be;
}
.exhibition-id .cell {
  padding: 0
}
</style>



// WEBPACK FOOTER //
// src/components/Result/Tables/TableExhibition.vue